import Account from "../Components/Account"
import Header from "../Components/header/PageHeader"
import '../account.css'

const Page = () => {

    return (
        <div className='mobile-layout'>
        <div className="scroll-y">
        <Header />
            <Account />
        </div>
        </div>
    )
    
    
}

export default Page